import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { CheckCircleIcon, TruckIcon, ClockIcon, BeakerIcon, ShieldIcon, PackageIcon, ThumbsUpIcon } from 'lucide-react';
export function App() {
  const [orderNumber, setOrderNumber] = useState('');
  useEffect(() => {
    // Generate a random 6-digit number
    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    setOrderNumber(`#BIO-${randomNumber}`);
  }, []); // Empty dependency array means this runs once on component mount (page refresh)
  return <div className="bg-gradient-to-b from-gray-900 to-blue-900 min-h-screen text-white font-sans" data-id="element-0">
      <div className="container mx-auto px-4 py-8 max-w-3xl" data-id="element-1">
        {/* Thank You Section */}
        <section className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8" data-id="element-2">
          <CheckCircleIcon className="w-16 h-16 text-green-400 mx-auto mb-4" data-id="element-3" />
          <h2 className="text-3xl font-bold mb-2" data-id="element-4">¡Gracias por tu compra!</h2>
          <p className="text-xl mb-6" data-id="element-5">Tu pedido ha sido confirmado con éxito</p>
          <div className="bg-white/20 p-4 rounded-lg inline-block" data-id="element-6">
            <p className="font-medium" data-id="element-7">
              Número de pedido: <span className="font-bold" data-id="element-8">{orderNumber}</span>
            </p>
          </div>
        </section>
        {/* What to Expect Section */}
        <section className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8" data-id="element-9">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-10">
            ¿Qué sigue ahora?
          </h3>
          <div className="space-y-6" data-id="element-11">
            <div className="flex items-start" data-id="element-12">
              <div className="bg-blue-700 p-3 rounded-full mr-4" data-id="element-13">
                <TruckIcon className="w-6 h-6" data-id="element-14" />
              </div>
              <div data-id="element-15">
                <h4 className="font-bold text-lg mb-1" data-id="element-16">Envío en camino</h4>
                <p className="text-gray-200" data-id="element-17">
                  Tu BioBooster será enviado en las próximas 24 horas. Recibirás
                  un correo con la información de seguimiento.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-18">
              <div className="bg-blue-700 p-3 rounded-full mr-4" data-id="element-19">
                <ClockIcon className="w-6 h-6" data-id="element-20" />
              </div>
              <div data-id="element-21">
                <h4 className="font-bold text-lg mb-1" data-id="element-22">Primeros resultados</h4>
                <p className="text-gray-200" data-id="element-23">
                  La mayoría de los hombres comienzan a notar mejoras en su
                  energía y deseo sexual en los primeros 3-7 días de uso
                  regular.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-24">
              <div className="bg-blue-700 p-3 rounded-full mr-4" data-id="element-25">
                <BeakerIcon className="w-6 h-6" data-id="element-26" />
              </div>
              <div data-id="element-27">
                <h4 className="font-bold text-lg mb-1" data-id="element-28">Uso recomendado</h4>
                <p className="text-gray-200" data-id="element-29">
                  Toma 2 cápsulas diariamente con agua, preferiblemente por la
                  mañana. Para mejores resultados, mantén un consumo
                  consistente.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Community Section */}
        <section className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8 text-center" data-id="element-30">
          <h3 className="text-2xl font-bold mb-6" data-id="element-31">
            Únete a la comunidad y recibe ofertas exclusivas
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8" data-id="element-32">
            <div className="bg-white p-4 rounded-lg" data-id="element-33">
              <QRCodeSVG value="https://wa.me/123456789?text=Quiero%20unirme%20al%20grupo%20VIP%20de%20BioBooster" size={150} data-id="element-34" />
            </div>
            <div className="flex flex-col" data-id="element-35">
              <p className="text-gray-200 mb-4" data-id="element-36">
                Escanea el código QR o haz clic en el botón para unirte a
                nuestro grupo VIP de WhatsApp
              </p>
              <a href="https://wa.me/123456789?text=Quiero%20unirme%20al%20grupo%20VIP%20de%20BioBooster" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-all flex items-center justify-center gap-2" data-id="element-37">
                Unirme al grupo VIP
              </a>
            </div>
          </div>
        </section>
        {/* Guarantees Section */}
        <section className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8" data-id="element-38">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-39">
            Nuestras garantías
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-40">
            <div className="text-center" data-id="element-41">
              <div className="bg-blue-700 p-4 rounded-full mx-auto mb-4 w-16 h-16 flex items-center justify-center" data-id="element-42">
                <PackageIcon className="w-8 h-8" data-id="element-43" />
              </div>
              <h4 className="font-bold mb-2" data-id="element-44">Envío discreto</h4>
              <p className="text-gray-200 text-sm" data-id="element-45">
                Empaque sin marcas y descripción neutral en tu estado de cuenta
              </p>
            </div>
            <div className="text-center" data-id="element-46">
              <div className="bg-blue-700 p-4 rounded-full mx-auto mb-4 w-16 h-16 flex items-center justify-center" data-id="element-47">
                <ShieldIcon className="w-8 h-8" data-id="element-48" />
              </div>
              <h4 className="font-bold mb-2" data-id="element-49">Pago seguro</h4>
              <p className="text-gray-200 text-sm" data-id="element-50">
                Tus datos financieros están protegidos con encriptación de nivel
                bancario
              </p>
            </div>
            <div className="text-center" data-id="element-51">
              <div className="bg-blue-700 p-4 rounded-full mx-auto mb-4 w-16 h-16 flex items-center justify-center" data-id="element-52">
                <ThumbsUpIcon className="w-8 h-8" data-id="element-53" />
              </div>
              <h4 className="font-bold mb-2" data-id="element-54">Satisfacción garantizada</h4>
              <p className="text-gray-200 text-sm" data-id="element-55">
                60 días de garantía de devolución de dinero sin preguntas
              </p>
            </div>
          </div>
        </section>
        {/* Footer */}
        <footer className="text-center text-gray-400 text-sm py-4" data-id="element-56">
          <p data-id="element-57">© 2023 BioBooster. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-58">
            Este producto no está destinado a diagnosticar, tratar, curar o
            prevenir ninguna enfermedad.
          </p>
        </footer>
      </div>
    </div>;
}